import React from 'react'
import { Link } from 'react-router-dom'
import './questionbank.css'

const QuestionBank = () => {
  return (
    <div className='qb_page'>
      <div className='qb_header'>
        <h1 className='qb_title'>Question Bank</h1>
        <p className='qb_subtitle'>
          Browse the full set of objective questions for every departmental
          examination subject. Choose a language to begin.
        </p>
      </div>

      {/* Hindi was previously a plain <div> styled to look identical to the
          English tile but wired to nothing — clicking it did nothing at all.
          The subject endpoint already accepts ?lang=HINDI, so both now link
          through to the same screen with their own language code. */}
      <div className='qb_lang_grid'>
        <Link className='qb_lang' to='/subject-page?lang=HINDI'>
          हिन्दी
          <span className='qb_lang_sub'>Hindi</span>
        </Link>

        <Link className='qb_lang' to='/subject-page?lang=ENG'>
          English
          <span className='qb_lang_sub'>अंग्रेज़ी</span>
        </Link>
      </div>

      <p className='qb_note'>
        <b>Note:</b> The question bank is revised and updated continuously.
        Please visit this page regularly for the latest questions.
      </p>
    </div>
  )
}

export default QuestionBank
